import ActionBarItem from '@rio-cloud/rio-uikit/ActionBarItem';
import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';
import { FormattedMessage } from 'react-intl';

import { UserManualMenu } from '@/features/userManual/components/UserManualMenu';
import { useWhatsNewStore } from '@/stores/whatsNewStore';

export const UserManualButton = () => {
    const { showNotification: showWhatsNewBadge } = useWhatsNewStore();

    return (
        <ActionBarItem id='serviceInfo'>
            <ActionBarItem.Icon>
                <OverlayTrigger
                    placement='bottom'
                    overlay={
                        <Tooltip id='tooltip' allowOnTouch>
                            <FormattedMessage id='general.userManual' />
                        </Tooltip>
                    }
                >
                    <span
                        className='icon rioglyph rioglyph-info-sign'
                        data-testid='user-manual-btn'
                        data-test-id='user-manual-btn'
                    />
                </OverlayTrigger>
                {showWhatsNewBadge && (
                    <span className='badge badge-indicator badge-primary margin-left-2' data-testid='whats-new-badge' />
                )}
            </ActionBarItem.Icon>
            <ActionBarItem.Popover
                title={
                    <span>
                        <FormattedMessage id='userManual.modalTitle' />
                    </span>
                }
            >
                <UserManualMenu />
            </ActionBarItem.Popover>
        </ActionBarItem>
    );
};
